<template>
   <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px"><path d="M54-207v-543h77v543H54Zm116 0v-543h78v543h-78Zm116 0v-543h39v543h-39Zm117 0v-543h77v543h-77Zm116 0v-543h117v543H519Zm156 0v-543h38v543h-38Zm116 0v-543h116v543H791Z"/></svg>
</template>
